import ApiService from "@/common/api.service";

export default {
  contactUs(data) {
    return ApiService.post("contact-us", data);
  }
};
